import {CmsApiClientProd} from "@/_global/api_clients/CmsApiClientProd";
import {CmsApiClientLocal} from "@/_global/api_clients/CmsApiClientLocal";

interface ICmsApiClient {
    getHealth: () => Promise<any>;
    getMenus: () => Promise<any>
    createMenu: (menu: CMS.Menu) => Promise<any>;
    editMenu: (menu: CMS.Menu) => Promise<any>;
    sortMenus: (order: number[]) => Promise<any>;
    deleteMenu: (menu: CMS.Menu) => Promise<any>;
    createMenuStore: (menu: CMS.Menu, storeId: number) => Promise<any>;
    deleteMenuStore: (menu: CMS.Menu, storeId: number) => Promise<any>;
    updateMenuStores: (menu: CMS.Menu) => Promise<any>;
    getSchedules: (menuId: number) => Promise<any>;
    createSchedule: (schedule: CMS.Schedule) => Promise<any>;
    editSchedule: (schedule: CMS.Schedule) => Promise<any>;
    deleteSchedule: (schedule: CMS.Schedule) => Promise<any>;
    getImages: () => Promise<any>
    createImage: (image: CMS.Image) => Promise<any>;
    editImage: (image: CMS.Image) => Promise<any>;
    deleteImage: (image: CMS.Image) => Promise<any>;
    getCategories: (menuId: number) => Promise<any>;
    createCategory: (category: CMS.Category) => Promise<any>;
    editCategory: (category: CMS.Category) => Promise<any>;
    deleteCategory: (category: CMS.Category) => Promise<any>;
    sortCategory: (menuId: number, order: number[]) => Promise<any>;
    getCategoryItems: (menuId: number) => Promise<any>;
    setCategoryItems: (menuId: number, categoryId: number, categoryItems: CMS.CategoryItem[]) => Promise<any>;
    getThemes: () => Promise<any>;
    getThemeVariable: (themeId: number, menuId: number) => Promise<any>;
    setThemeVariable: (themeVariable: CMS.ThemeVariable) => Promise<any>;
    getThemeCategoryVariables: (themeId: number, menuId: number) => Promise<any>;
    setThemeCategoryVariable: (themeCategoryVariable: CMS.ThemeCategoryVariable) => Promise<any>;
    getThemeItemVariables: (themeId: number) => Promise<any>;
    setThemeItemVariable: (themeItemVariable: CMS.ThemeItemVariable) => Promise<any>;
    getItems: () => Promise<any>;
    setItem: (item: CMS.Item) => Promise<any>;
    getSelections: () => Promise<any>;
    setSelection: (selection: CMS.Selection) => Promise<any>;
    getCondimentGroups: () => Promise<any>;
    setCondimentGroup: (condimentGroup: CMS.CondimentGroup) => Promise<any>;
    getDeliousItemDetailList: (storeId: number, periodId: number) => Promise<any>;
    uploadFile: (formData: FormData) => Promise<any>;
}

export let CmsApiClient: ICmsApiClient = CmsApiClientProd;


export function cmsApiClientToLocalMode() {
    CmsApiClient = CmsApiClientLocal;
}

